import { render } from "./IndexDevis.vue?vue&type=template&id=daf171b2"
import script from "./IndexDevis.vue?vue&type=script&lang=js"
export * from "./IndexDevis.vue?vue&type=script&lang=js"

import "./IndexDevis.vue?vue&type=style&index=0&id=daf171b2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__